import AsyncStorage from '@react-native-async-storage/async-storage'
import { Platform } from '../libs/platform'

export default Platform.select({
  web: () => require('localforage'),
  default: () => AsyncStorage,
})()
